import { UserPasswordViewModel, getGetApiAdminUserManagerListUsersQueryKey, usePostApiAdminUserManagerCreateUser, } from "@/API";
import { Button, Group, Modal, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export function CreateUserDialog(props: { opened: boolean, onClose: () => void }) {
    const queryClient = useQueryClient()
    const CreateUser_Mutation = usePostApiAdminUserManagerCreateUser()
    const form = useForm<UserPasswordViewModel>({
        initialValues: {
            userName: "",
            password: "",
            displayName: ""
        },
        validate: {
            userName: (value) => {
                if (!value) return "使用者帳號不得為空"
                if (/\s/.test(value)) return "使用者帳號不得含有空白字元"
                return null
            },
            password: (value) => (!value ? '使用者密碼不得為空' : null),
        },
    });
    return <>
        <Modal opened={props.opened} onClose={props.onClose} title="新增使用者">
            <form onSubmit={form.onSubmit(async (values) => {
                try {
                    await CreateUser_Mutation.mutateAsync({ data: values })
                    queryClient.invalidateQueries({ queryKey: getGetApiAdminUserManagerListUsersQueryKey() })
                    notifications.show({ message: "新增成功" })
                    props.onClose()
                } catch (e) {
                    var error = e as AxiosError
                    var msg = error.response?.data
                    notifications.show({ message: "新增失敗" + (msg ? `:${msg}` : ""), color: "red" })

                }
            })}>
                <TextInput
                    withAsterisk
                    label="使用者帳號"
                    placeholder="user name"
                    {...form.getInputProps('userName')}
                />
                <TextInput
                    withAsterisk
                    label="使用者密碼"
                    placeholder="user password"
                    type="password"
                    {...form.getInputProps('password')}
                />
                <TextInput
                    label="使用者顯示名稱"
                    placeholder="user display name"
                    {...form.getInputProps('displayName')}
                />
                <Group justify="flex-end" mt="md">
                    <Button type="submit">新增</Button>
                </Group>
            </form>
        </Modal>
    </>
}